// extracted by css-extract-rspack-plugin
export default {"plainLink":"a8xV6"};